// extracted by mini-css-extract-plugin
export default {"videoCutsPageContainer":"VideoCutsPage_videoCutsPageContainer__K+EZ+","videoCutsWrapper":"VideoCutsPage_videoCutsWrapper__wSSo9"};